import Vue from "vue";
import Component from "vue-class-component";
import LoaderComponent from "@/components/loader/loader.component.vue";
// Services
import CandidateService from "@/core/services/candidate.service";
import ReportService from "@/core/services/report.service";
import JobService from "@/core/services/job.service";
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas';
interface actProps {
    id: number
    name: string
    result: { percentage:number }
}
interface actAverageProps {
    average: string
    description: string
}

@Component({
  components: {
    LoaderComponent,
  },
})


export default class ActComponent extends Vue {
  candidateService: any = new CandidateService();
  reportService: any = new ReportService();
  jobService: any = new JobService();
  isLoading: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  createdAt: string = "";
  name: string = "";
  companiesName: string = "";
  surname: string = "";
  companies: string = "";
  jobs: string = "";
  sumEffectiveness: number = 0;
  averageEffectiveness: number = 0;
  sumAdministrative: number = 0;
  averageAdministrative: number = 0;
  sumCommunicative: number = 0;
  averageCommunicative: number = 0;
  sumIntegration: number = 0;
  averageIntegration: number = 0;
  sumCognitive: number = 0;
  averageCognitive: number = 0;
  public base64Logo: string = "";
  // Leadership Skills
  x: boolean = false;
  y: boolean = false;
  situational: boolean = false;

  personalSortedArray: any = [];
  communicationSortedArray: any = [];
  // External report variables
  anima_old_onResize: any;
  anima_new_onResize: any;

  //New data
  contribution : actProps = {
    id: 0,
    name: "",
    result: { percentage : 0}
  }
  customerFocus : actProps = {
    id: 0,
    name: "",
    result: { percentage : 0}
  }
  management : actProps = {
    id: 0,
    name: "",
    result: { percentage : 0}
  }
  leadership : actProps = {
    id: 0,
    name: "",
    result: { percentage : 0}
  }
  improvement : actProps = {
    id: 0,
    name: "",
    result: { percentage : 0}
  }
  participation : actProps = {
    id: 0,
    name: "",
    result: { percentage : 0}
  }
  // Communication Style Skills
  empathic : actProps = {
    id: 0,
    name: "",
    result: { percentage : 0}
  }
  critical : actProps = {
    id: 0,
    name: "",
    result: { percentage : 0}
  }
  inquisitive : actProps = {
    id: 0,
    name: "",
    result: { percentage : 0}
  }
  adviser : actProps = {
    id: 0,
    name: "",
    result: { percentage : 0}
  }
  // Personal Style Skills
  sensitive : actProps = {
    id: 0,
    name: "",
    result: { percentage : 0}
  }
  analytical : actProps = {
    id: 0,
    name: "",
    result: { percentage : 0}
  }
  asset : actProps = {
    id: 0,
    name: "",
    result: { percentage : 0}
  }
  creative : actProps = {
    id: 0,
    name: "",
    result: { percentage : 0}
  }


  contributionAverage : actAverageProps= {
    average: "",
    description: ""
  }
  customerFocusAverage : actAverageProps= {
    average: "",
    description: ""
  }
  managementAverage : actAverageProps= {
    average: "",
    description: ""
  }
  leadershipAverage : actAverageProps= {
    average: "",
    description: ""
  }
  improvementAverage : actAverageProps= {
    average: "",
    description: ""
  }
  participationAverage : actAverageProps= {
    average: "",
    description: ""
  }

  public logo: any;
  public leftDefault = 211;

  mounted() {
    const _ = this;

    //  External Report
    _.anima_old_onResize = window.onresize;
    _.anima_new_onResize = undefined;
    _.anima_updateOnResize();
  }

  async created() {
    const _ = this;
    await _.getProfileReport();
    _.filterDate();
  }

  anima_updateOnResize() {
    const _ = this;
    if (
      _.anima_new_onResize == undefined ||
      window.onresize != _.anima_new_onResize
    ) {
      window.onresize = _.anima_new_onResize;
      setTimeout(function() {
        _.anima_updateOnResize();
      }, 3000);
    }
  }

  filterDate(date: any = "") {
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  async getProfileReport() {
    const _ = this;
    let userId: any = location.href.split("/");
    userId = userId[4];
    let profileId: any = location.href.split("/");
    profileId = {
      profileId: profileId[6],
    };
    await _.candidateService.getById(userId).then((data: any) => {
      _.name = data["data"].user.name;
      _.surname = data["data"].user.surname;
      _.createdAt = data["data"].user.createdAt;
      _.companiesName = data["data"].user.company.name;
      _.logo = data["data"].user.company.logo;
    });
    await _.reportService
      .getProfileReport(userId, profileId)
      .then((data: any) => {
        for (let j = 0; j < data["data"].report.act.length; j++) {
          if (
            data["data"].report.act[j].name
              .toLowerCase()
              .includes("contribución")
          ) {
            _.contribution =
              data["data"].report.act[j]
                ? data["data"].report.act[j]
                : 0;
          }
          if (
            data["data"].report.act[j].name
              .toLowerCase()
              .includes("enfoque al cliente")
          ) {
            _.customerFocus =
              data["data"].report.act[j]
                ? data["data"].report.act[j]
                : 0;
          }
          if (
            data["data"].report.act[j].name
              .toLowerCase()
              .includes("gestión")
          ) {
            _.management =
              data["data"].report.act[j]
                ? data["data"].report.act[j]
                : 0;
          }
          if (
            data["data"].report.act[j].name
              .toLowerCase()
              .includes("liderazgo")
          ) {
            _.leadership =
              data["data"].report.act[j]
                ? data["data"].report.act[j]
                : 0;
          }
          if (
            data["data"].report.act[j].name
              .toLowerCase()
              .includes("mejora")
          ) {
            _.improvement =
              data["data"].report.act[j]
                ? data["data"].report.act[j]
                : 0;
          }
          if (
            data["data"].report.act[j].name
              .toLowerCase()
              .includes("participación")
          ) {
            _.participation =
              data["data"].report.act[j]
                ? data["data"].report.act[j]
                : 0;
          }
        }
        for (let j = 0; j < data["data"].report.auto.length; j++) {
          const skillName = data["data"].report.auto[j].name;
          if(skillName === "Sensible"){
            _.sensitive = data["data"].report.auto[j]
          }
          if(skillName === "Analítico"){
            _.analytical = data["data"].report.auto[j]
          }
          if(skillName === "Activo"){
            _.asset = data["data"].report.auto[j]
          }
          if(skillName === "Creativo"){
            _.creative = data["data"].report.auto[j]
          }
        }
        for (let j = 0; j < data["data"].report.communication.length; j++) {
          const skillName = data["data"].report.communication[j].name;
          if(skillName === "Empático"){
            _.empathic = data["data"].report.communication[j]
          }
          if(skillName === "Crítico"){
            _.critical = data["data"].report.communication[j]
          }
          if(skillName === "Consejero"){
            _.adviser = data["data"].report.communication[j]
          }
          if(skillName === "Inquisitivo"){
            _.inquisitive = data["data"].report.communication[j]
          }
        }

        const getAverage =  (percentage: number, skill: string) => {

            if(percentage >= 0 && percentage <= 20){
              if(skill === "contributions"){
                _.contributionAverage = { 
                  average: "Deficiente",
                  description: "Genera los resultados que de su puesto se esperan, asegurando el tiempo de respuesta"
                }
              }
              if(skill === "customerFocus"){
                _.customerFocusAverage = { 
                  average: "Deficiente",
                  description: "Conoce los productos y servicios que provee, atendiendo a las necesidades expresas de sus clientes"
                }
              }
              if(skill === "management"){
                _.managementAverage = { 
                  average: "Deficiente",
                  description: "Cumple con sus objetivos apegándose a los estándares de cumplimiento de su puesto"
                }
              }
              if(skill === "leadership"){
                _.leadershipAverage = { 
                  average: "Deficiente",
                  description: "Es congruente con sus propuestas y acciones, motivando a través de su ejemplo para el cumplimiento de los resultados"
                }
              }
              if(skill === "improvement"){
                _.improvementAverage = { 
                  average: "Deficiente",
                  description: "Identifica los problemas a los que se enfrenta en la operación y establece criterios para la solución inmediata"
                }
              }
              if(skill === "participation"){
                _.participationAverage = { 
                  average: "Deficiente",
                  description: "Transmite mensajes de manera clara a sus interlocutores, logrando el entendimiento de sus ideas y propuestas"
                }
              }

              return
            } 
            if(percentage >= 21 && percentage <= 40){
              if(skill === "contributions"){
                _.contributionAverage = { 
                  average: "Regular",
                  description: "Cumple con los estándares establecidos en un mínimo de tiempo, tomando acciones inmediatas que le aseguren los resultados"
                }
              }
              if(skill === "customerFocus"){
                _.customerFocusAverage = { 
                  average: "Regular",
                  description: "Se asegura que las necesidades del cliente sean cubiertas en tiempo y oportunidad, logrando cumplir con sus necesidades y expectativas"
                }
              }
              if(skill === "management"){
                _.managementAverage = { 
                  average: "Regular",
                  description: "Establece puntos de monitoreo y seguimiento que permitan eficientar el uso de recursos o procedimientos"
                }
              }
              if(skill === "leadership"){
                _.leadershipAverage = { 
                  average: "Regular",
                  description: "Dirige al equipo y colabora con la dirección del líder hacia la obtención de los resultados del equipo"
                }
              }
              if(skill === "improvement"){
                _.improvementAverage = { 
                  average: "Regular",
                  description: "Establece alternativas de solución para erradicar los problemas, tomando en cuenta los efectos de estas acciones en el corto y mediano plazo"
                }
              }
              if(skill === "participation"){
                _.participationAverage = { 
                  average: "Regular",
                  description: "Adecua sus mensajes acorde al entorno en el que se comunique, generando confianza en sus interlocutores"
               }
              }
              return
            } 
            if(percentage >= 41 && percentage <= 60){
              if(skill === "contributions"){
                _.contributionAverage = { 
                  average: "Promedio",
                  description: "Compara sus resultados con los de otros compañeros o áreas para optimizar el desempeño y toma las decisiones necesarias"
                }
              }
              if(skill === "customerFocus"){
                _.customerFocusAverage = { 
                  average: "Promedio",
                  description: "Visualiza anticipadamente las necesidades del cliente, ofreciéndole servicios y productos integrales  que puede adecuar a sus expectativas futuras"
                }
              }
              if(skill === "management"){
                _.managementAverage = { 
                  average: "Promedio",
                  description: "Define objetivos realistas y congruentes con la visión y entorno; administra eficazmente los recursos impactando a las demás áreas implícitas en su proceso"
                }
              }
              if(skill === "leadership"){
                _.leadershipAverage = { 
                  average: "Promedio",
                  description: "Asume un rol de líder en el equipo, estableciendo parámetros para las acciones tanto individuales como colectivas"
                }
              }
              if(skill === "improvement"){
                _.improvementAverage = { 
                  average: "Promedio",
                  description: "Toma decisiones con el propósito de erradicar los problemas de manera integral y comprometiéndose con los efectos"
                }
              }
              if(skill === "participation"){
                _.participationAverage = { 
                  average: "Promedio",
                  description: "Genera argumentos sólidos que son aceptados por sus interlocutores, logrando modificar sus puntos de vista e ideas"
                }
              }
              return
            } 
            if(percentage >= 61 && percentage <= 80){
              if(skill === "contributions"){
                _.contributionAverage = { 
                  average: "Superior",
                  description: "Optimiza el desempeño de su equipo de trabajo a través del seguimiento y la evaluación frente a los resultados esperados"
                }
              }
              if(skill === "customerFocus"){
                _.customerFocusAverage = { 
                  average: "Superior",
                  description: "A través de la retro información del cliente mejora continuamente los procesos, servicios y productos que se ofrecen"
                }
              }
              if(skill === "management"){
                _.managementAverage = { 
                  average: "Superior",
                  description: "Administra sus recursos con base a las tendencias organizacionales, prevé los impactos del entorno y su efecto"
                } 
              }
              if(skill === "leadership"){
                _.leadershipAverage = { 
                  average: "Superior",
                  description: "Adecua su estilo de liderazgo con el propósito de optimizar el desempeño de los integrantes del equipo"
                }
              }
              if(skill === "improvement"){
                _.improvementAverage = { 
                  average: "Superior",
                  description: "Se anticipa a los problemas de su ámbito de influencia, generando acciones congruentes e innovadoras que generen un cambio positivo"
                }
              }
              if(skill === "participation"){
                _.participationAverage = { 
                  average: "Superior",
                  description: "Convence a sus interlocutores y logra el acuerdo a través de sus propuestas, llegando a conciliar intereses opuestos "
                }
              }
              return
            } 
            if(percentage >= 81 && percentage <= 100){
              if(skill === "contributions"){
                _.contributionAverage = { 
                  average: "Excelente",
                  description: "Encamina a la organización en un enfoque de urgencia y prioridad hacia los objetivos estratégicos"
                }
              }
              if(skill === "customerFocus"){
                _.customerFocusAverage = { 
                  average: "Excelente",
                  description: "Excede las expectativas del cliente y ha generado valor a través de la confianza en sus relaciones al ofrecerle servicios y productos  integrales"
                }
              }
              if(skill === "management"){
                _.managementAverage = { 
                  average: "Excelente",
                  description: "Se anticipa a las tendencias de la industria, planteando escenarios innovadores donde existan ventajas competitivas sobre la competencia y el entorno"
                }
              }
              if(skill === "leadership"){
                _.leadershipAverage = { 
                  average: "Excelente",
                  description: "Inspira a través de su actuación y potencializa las capacidades de los integrantes, logrando alta motivación y compromiso para con la organización"
                }
              }
              if(skill === "improvement"){
                _.improvementAverage = { 
                  average: "Excelente",
                  description: "Visualiza oportunidades para el negocio y genera estrategias que le permitan anticiparse a las tendencias de la industria, estableciendo la directriz global "
                }
              }
              if(skill === "participation"){
                _.participationAverage = { 
                  average: "Excelente",
                  description: "Negocia las propuestas e intereses de las partes, logrando un consenso favorable para los resultados de la organización"
                }
              }
              return
            } 
        }

        getAverage(_.contribution.result.percentage, "contributions")
        getAverage(_.customerFocus.result.percentage, "customerFocus")
        getAverage(_.management.result.percentage, "management")
        getAverage(_.leadership.result.percentage, "leadership")
        getAverage(_.improvement.result.percentage, "improvement")
        getAverage(_.participation.result.percentage, "participation")
      })
      .catch(() => {});
    _.printReport()
  }

  private async reportToPDF() {
    const pdfDoc = new jsPDF("p", "mm", "a4");
    const htmlPages = document.querySelectorAll('.report-page-to-print'); // Replace '.html-page' with your HTML page selector
    for (const htmlPage of htmlPages) {
      await this.pageToPDF(htmlPage, pdfDoc);
    }
  
    pdfDoc.save(`${this.name}-${this.surname}-${this.companiesName}-ACT-Reporte.pdf`);

  }

  private async pageToPDF(htmlPage, pdfDoc) {
    const elementToPrint = document.getElementById("test-html-to-canvas");
    return await html2canvas(htmlPage, { 
      scale: 4, 
      useCORS: true, 
      allowTaint : true,
    }).then(function(canvas) {
      const pageToImage = canvas.toDataURL("image/jpeg", 1)

      const width = pdfDoc.internal.pageSize.getWidth();;
      const height = pdfDoc.internal.pageSize.getWidth();;
      const numberOfPages = pdfDoc.getNumberOfPages();
      pdfDoc.addImage(pageToImage, "JPEG", 0, 0, width, 300)
      if(numberOfPages < 10) {
        pdfDoc.addPage();
      }
    });
  }

  private getBase64Image(imgElement) {
    // Create a canvas element
    const canvas = document.createElement("canvas");
    canvas.width = imgElement.width;
    canvas.height = imgElement.height;
    
    // Get 2D rendering context for the canvas
    const ctx = canvas.getContext("2d");
  
    // Draw the image onto the canvas
    ctx.drawImage(imgElement, 0, 0);
    // Convert the canvas content to a base64-encoded data URL (PNG format)
    const dataURL = canvas.toDataURL("image/jpeg");
    // Remove the data URL prefix, leaving only the base64-encoded image data
    return dataURL.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
  }
  


  printReport() {
    setTimeout(() => {
      // window.print();
      this.reportToPDF()
    }, 4000);
  }
}
